import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { CrmNoteType } from '@plato/data/prisma';
import { keepPreviousData } from '@tanstack/react-query';
import { ActivityFeedModelType } from '../../../server/types/customer-activity-feed-types.ts';
import { api } from '../../../utils/api.ts';
import { useActivityFilters } from './use-activity-filters.ts';

export function useActivityUpcomingEvents(customerId?: string) {
    const { enableCustomerEventPlanning } = useAppConfig();

    const { appliedFilters } = useActivityFilters();

    const modelType = appliedFilters.modelType;
    const noteTypes = appliedFilters.noteTypes ?? [];
    const hasOtherFilters = [
        appliedFilters.orderStatuses,
        appliedFilters.quoteStatuses,
        appliedFilters.taskStatuses,
    ].some((value) => !!value?.length);

    const isEnabled =
        enableCustomerEventPlanning &&
        !!customerId &&
        (!modelType || modelType === ActivityFeedModelType.NOTE) &&
        (!!modelType || !hasOtherFilters || noteTypes.length > 0) &&
        (noteTypes.length === 0 || noteTypes.includes(CrmNoteType.VISIT));

    const queryResult = api.platoUser.query.events.getUpcomingCustomerEvents.useQuery(
        {
            customerId: customerId ?? '',
        },
        {
            enabled: isEnabled,
            placeholderData: keepPreviousData,
        },
    );

    return {
        ...queryResult,
        isLoading: isEnabled && queryResult.isLoading,
        isEnabled,
        events: isEnabled ? queryResult.data || [] : [],
    };
}
